import PropTypes from 'prop-types';
import React from 'react';
import { ReactComponent as Animation } from '../../../assets/icons/intro/gyro.svg';
import PrimaryButton from '../../../components/buttons/primarybutton/PrimaryButton';
import SecondaryButton from '../../../components/buttons/secondarybutton/SecondaryButton';
import Header from '../../../components/header/Header';
import H2 from '../../../components/text/H2';
import { tag } from '../../../services/ATInternetService';

const Gyro = ({ onNextSlideRequested, onPrevSlideRequested }) => {
	return (
		<>
			<section className="intro__slide--start">
				<Header className="fixed top-0" />
				<div className="overflow-y-auto overflow-x-hidden w-screen pt-12 px-4">
					<div className="bg-white bg-opacity-10 rounded-3xl m-auto max-w-4xl px-4 pt-4">
						<Animation className="intro__animation" />
						<H2 className="py-6 text-center">
							Met de richtings-toestemming kan je de 3d modellen echt in je kamer zien!<br />
							Wil je dat?
						</H2>
						<div className="flex flex-col w-full px-8">
							<PrimaryButton onClick={() => {
								// @ts-ignore
								DeviceOrientationEvent.requestPermission()
									.then(response => {
										if (response === 'granted') {
											onNextSlideRequested('gyro');
											tag.sendClick('intro', {
												chapter3: 'gyro',
												name: 'permission-granted',
											});
										}
									})
									.catch(() => {
										tag.sendClick('intro', {
											chapter3: 'gyro',
											name: 'permission-denied',
										});
									})
							}}>
								Ja
							</PrimaryButton>
							<SecondaryButton className="text-red-500" onClick={onPrevSlideRequested}>
								Liever niet
							</SecondaryButton>
						</div>
					</div>
				</div>
			</section>
		</>
	);
}

Gyro.propTypes = {
	onNextSlideRequested: PropTypes.func.isRequired,
	onPrevSlideRequested: PropTypes.func.isRequired,
}

export default Gyro
